import { retrieveInsuranceQuoteUrl } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';

export const RetrieveService = {
  /**
   * Retrieve quote form url
   * @param quoteNumber
   * @param postcode
   * @returns
   */
  retrieveQuote: (quoteNumber: string, postcode: string) => {
    return _http.HttpGet(retrieveInsuranceQuoteUrl.replace('{0}', quoteNumber).replace('{1}', postcode));
  },
};
